import React from "react";
import Navbar from "./Navbar";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import "../App.css";
import Home from "./pages/Home";
import MemesForSale from "./pages/MemesForSale";
import LoginPage from "./pages/LoginPage";
import SignUp from "./pages/SignUp";
import NotFoundPage from "./pages/NotFoundPage";
import ProfilePage from "./pages/ProfilePage";
import ForgotPassword from "./pages/ForgotPassword";
import UploadImagePage from "./pages/UploadImagePage";
import AboutPage from "./pages/AboutPage";
import ImagePage from "./pages/ImagePage";

export default function AppRouter(props) {
  return (
    <>
      <Router>
        <Navbar />
        <Switch>
          <Route exact path="/" component={Home} />
          <Route exact path="/gallery" component={MemesForSale} />
          <Route exact path="/login" component={LoginPage} />
          <Route exact path="/signup" component={SignUp} />
          <Route exact path="/profile" component={ProfilePage} />
          <Route exact path="/forgot-password" component={ForgotPassword} />
          <Route exact path="/upload" component={UploadImagePage} />
          <Route exact path="/about" component={AboutPage} />
          <Route exact path="/gallery/:imageid" component={ImagePage} />
          <Route exact path="*" component={NotFoundPage} />
        </Switch>
      </Router>
    </>
  );
}
